import apiFetch from '../apiFetch'

export default function (token, presentId) {
  return apiFetch({ endPoint: `PresentType/${presentId}`, method: 'DELETE', body: null, token: token })
}
